import { render, staticRenderFns } from "./InactivityWarning.vue?vue&type=template&id=487cb0c0&scoped=true"
import script from "./InactivityWarning.vue?vue&type=script&lang=ts"
export * from "./InactivityWarning.vue?vue&type=script&lang=ts"
import style0 from "./InactivityWarning.vue?vue&type=style&index=0&id=487cb0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cb0c0",
  null
  
)

export default component.exports